import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const overrideCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService: StorageService = inject(StorageService);
  const override: string | null = storageService.getItem('overrideCache');

  if (!override) {
    return next(req);
  }

  const overrideRequest = req.clone({
    setParams: {
      overrideCache: override,
    },
  });

  return next(overrideRequest);
};
